module.exports = __webpack_public_path__ + "img/240.dust.0f4cd72d.svg";